const ModeActions = {
    Switch: "MODE.SWITCHTO"
};

module.exports = ModeActions;


// WEBPACK FOOTER //
// ./src/actions/ModeActions.js